import React from 'react';
import { QuestionTemplate } from '@Models/QuestionTemplate';
import { Metric } from '@Models/Metric';

type State = {
    questions: {
        [id: string]: QuestionTemplate
    },
    metrics: {
        [id: string]: Metric
    }
};

const emptyState: State = {
    questions: {},
    metrics: {}
}

type ContextType = State;

export const QuestionsAndMetricsContext = React.createContext<ContextType>({
    ...emptyState
});

export function QuestionsAndMetricsContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    return <QuestionsAndMetricsContext.Provider value={props.initialState || emptyState}>{props.children}</QuestionsAndMetricsContext.Provider>;
}
